import * as commonTranslations from './locales'

let i18n;

function addCommonTranslations(i18n)
{
    initializeI18n(i18n);

    for(let lng in commonTranslations)
    {
        i18n.addResourceBundle(lng, 'common', commonTranslations[lng])
    }
}

function initializeI18n(initialized_i18n)
{
    i18n = initialized_i18n
}

function currentI18n()
{
    if(i18n === undefined)
    {
        console.error('i18n is not initialized');
    }
    return i18n;
}

export { addCommonTranslations, currentI18n}
